import { render, staticRenderFns } from "./SectionSplit.vue?vue&type=template&id=30ed613c&scoped=true"
import script from "./SectionSplit.vue?vue&type=script&lang=js"
export * from "./SectionSplit.vue?vue&type=script&lang=js"
import style0 from "./SectionSplit.vue?vue&type=style&index=0&id=30ed613c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ed613c",
  null
  
)

export default component.exports